import*as a from"react";const t=({children:n})=>a.Children.count(n)===0?null:a.createElement("span",{className:"visually-hidden"},n);var e=t;export{e as default};
//# sourceMappingURL=visually-hidden.js.map
